/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-18 09:33:19
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

export default  ({ label, list = [], color = [] }) => {
  const len = list.length;
  const width = 100 / len;

  return {
    title: {
      // text: 'World Population'
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    color,
    legend: { show: false },
    grid: {
      left: 0,
      right: 0,
      bottom: '3%',
      containLabel: false
    },
    series: list.map((item, index) => {
      return {
        name: item.name,
        type: 'pie',
        // radius: 70,
        radius: ['20%', '66%'],
        center: [`${width * index + width / 2}%`, '50%'],
        data: item.list.map((ele, i) => ({
          name: label[i],
          value: ele,
        })),
      }
    })
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P17/chart.js